import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import * as Setting from '../../utils/AuthUtils'
import Stage from './Stage';
import { api } from '../../AppConfig';



function RoutedStage() {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const stageQuery = useQuery({ 
    queryKey: [`stage${id}`], 
    queryFn: () => 
      fetch(api.stages().detailsById(id).href,{
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        }})
        .then((res) =>
          res.json(), 
      )
  })

  const participantsQuery = useQuery({ 
    queryKey: [`participants${id}`], 
    queryFn: () => 
      fetch(api.stages().players(id).href,{
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        }})
        .then((res) =>
          res.json(), 
      )
  })
  const waitlistQuery = useQuery({ 
    queryKey: [`waitlist${id}`], 
    queryFn: () => 
      fetch(api.stages().waitlist(id).href).then((res) =>
        res.json(), 
      )
  })

  const archetypesQuery = useQuery({
    queryKey: ['archetypes'],
    queryFn: () => 
      fetch(api.decks().archetypesList().href).then((res) =>
        res.json(), 
      )
  })
        
  const addPlayerQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.stages().addPlayer(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })},
    onSuccess: async () => {
      // Invalidate and refetch
      message.success('Successfully added player to event!');
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`waitlist${id}`] })
      window.location.reload(false)
    },
  })

  const subscribeQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.stages().subscribe(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })},
    onSuccess: async () => {
      // Invalidate and refetch
      message.success('Successfully signed to event!');
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`waitlist${id}`] })
      // window.location.reload(false)
    },
  })

  const rankingUpdateQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.stages().setRanking(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p.players),
      })},
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Ranking successfully updated!');
      // window.location.reload(false)
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`waitlist${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`stage${id}`] })
      window.location.reload(false)
    },
  })

  const deletePlayerQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.stages().removePlayer(p.stageId).href, {
        method: 'DELETE',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })},
    onSuccess: async () => {
      // Invalidate and refetch
      message.success('Player successfully removed!');
      // window.location.reload(false)
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`waitlist${id}`] })
      window.location.reload(false)
    }
  })

  const addDecklistQuery = useMutation({
    mutationFn: async (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      // console.warn('son arrivato a chiamare i ws per aggiungere un mazzo, chiamo questa url:', api.decks().add(p.stageId,p.isTournament,p.playerId).href);
      const response = await fetch(api.decks().add(p.stageId,p.isTournament,p.playerId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        throw new Error(errorData.message || 'An error occurred while adding the decklist.');
      }

      return response.json();
    },
    // we need to catch the error in onError, otherwise it is swallowed and the user does not see any message
    // but it doesn
    onError: () => {
      console.warn('data arrivati dopo onError:');
      message.error('Operation failed! Contact administrator for more information.');
    },
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Decklist successfully updloaded!');
      // window.location.reload(false)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // window.location.reload(false)
    },
  })

  const pending = (participantsQuery.isPending || waitlistQuery.isPending || stageQuery.isPending)
  if (!id) return (<div></div>);

  return <Stage 
            id={id} 
            pending={pending} 
            stage={stageQuery.data} 
            archetypes={archetypesQuery}
            participants={participantsQuery.data} 
            waitlist={waitlistQuery.data} 
            addPlayer={addPlayerQuery} 
            deletePlayer={deletePlayerQuery} 
            subscribe={subscribeQuery} 
            updateRanking={rankingUpdateQuery} 
            addDecklist={addDecklistQuery}
  />;
}

export default RoutedStage;